import React from 'react';
import KeycapOverlay from './KeycapOverlay';
import StaticKeycapShadows from './StaticKeycapShadows';
import { PunchingHoles, MoldBorder, ScrewHoles } from '../MoldPrintMarks';
import {
  getSlotPrintArea,
  PRINTING_SHEET,
} from '../../../../utils/moldGeometry';
import {
  printingLabel,
  printingLabelPaint,
} from '../../../../utils/keycapLabels';

// One printing run of an order's design, as ProcessOrderScreen shows it and its download
// clones it into the run's file (out of the screen in chain 12): the A3 sheet with every
// keycap of the run as a block of its colour on its slot's printed area, the legends and icons
// on top (KeycapOverlay) and the mold's marks; the labels, shadows, grids and areas are the
// preview's, which the download asks about first (printingSettingsWarning).
const PrintingRunSvg = ({
  designId,
  runIndex,
  keycaps,
  holePositions,
  showLabels,
  show2x2Grid,
  show3x3Grid,
  showPrintableArea,
  showTopSurface,
  showShadows,
  showPunchingHoles,
  showMoldBorder,
  showScrewHoles,
  fonts,
  setFonts,
  loadFont,
  userIconAssetsById,
  refreshUserIconAsset,
  orderItemIndex,
  triggerKeycapShadowRerender,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${PRINTING_SHEET.width} ${PRINTING_SHEET.height}`}
    style={{
      maxWidth: 420,
      width: '100%',
      height: 'auto',
      overflow: 'visible',
    }}
    version="1.1"
    id={`printingSVG-${designId}-${runIndex}`}
  >
    {/* Keycap Color: */}
    {keycaps.map((keycap, keycapIndex) => {
      const area = getSlotPrintArea(keycap); // the slot's printed area around its adjusted centre

      return (
        <g key={`keycap-${designId}-${runIndex}-${keycapIndex}`}>
          <rect {...area} fill={keycap.color} />

          {/* the size label is never empty (keycapSizeLabel), so the condition on it went in chain 9 */}
          {showLabels && (
            <text
              x={area.x + 1}
              y={area.y + 4.7}
              {...printingLabelPaint(keycap)} // the size and the contrasting colour, a homing-bar mark red with an outline on a reddish keycap
              fontWeight="bold"
              textAnchor="start"
              paintOrder="stroke"
            >
              {printingLabel(keycap)}
            </text>
          )}
        </g>
      );
    })}

    <KeycapOverlay
      keycapData={keycaps}
      userIconAssetsById={userIconAssetsById}
      refreshUserIconAsset={refreshUserIconAsset}
      fonts={fonts}
      setFonts={setFonts}
      show2x2Grid={show2x2Grid}
      show3x3Grid={show3x3Grid}
      showPrintableArea={showPrintableArea}
      showTopSurface={showTopSurface}
      loadFont={loadFont}
      orderItemIndex={orderItemIndex}
      runIndex={runIndex}
    />

    {showShadows && (
      <StaticKeycapShadows
        keycapData={keycaps}
        triggerKeycapShadowRerender={triggerKeycapShadowRerender}
      />
    )}

    <g>
      {showPunchingHoles && holePositions && (
        <PunchingHoles positions={holePositions} />
      )}
      {showMoldBorder && <MoldBorder />}
      {showScrewHoles && <ScrewHoles />}
    </g>
  </svg>
);

export default PrintingRunSvg;
